/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import {SignalAdminResourcePageState} from '../../common/controller/signal-admin-resource-page-state';
import {TeamModel} from './team-api.service';

@Component({
  standalone: false,
  selector: 'adn-team-item-page',
  template: `
    <adn-two-panel-layout>
      <adn-team-edit-page leftPanel [state]="state"></adn-team-edit-page>
      <adn-team-analysis-page rightPanel [model]="state.model()" [isNew]="state.isNew()"></adn-team-analysis-page>
    </adn-two-panel-layout>
  `
})
export class TeamItemPageComponent {
  @Input() state: SignalAdminResourcePageState<TeamModel>;
}
